
import { defineStore } from 'pinia';

const collapsedHeight = '29dvh';
const expandedHeight = 'calc(100dvh - 170px)';
const expandedHeightMobile = 'calc(100dvh - 146px)';

export const useTributeEditorStore = defineStore('tribuetEditor', {
    state: () => ({
        expanded: false,
        workspaceHeight: collapsedHeight,
        forceExpanded: false,
    }),
    actions: {
        toggleExpandedState() {
            if (this.forceExpanded && this.expanded) return;

            this.expanded = !this.expanded;
            this.workspaceHeight = this.expanded ? expandedHeight : collapsedHeight;
        },
        setExpandedState(isExpanded) {
            if (this.forceExpanded && !isExpanded) return;
            this.expanded = isExpanded;
            this.workspaceHeight = this.expanded ? expandedHeight : collapsedHeight;
        },
        setWorkspaceHeight(height) {
            this.workspaceHeight = height;
        },
        setForceExpanded(forceExpanded) {
            this.forceExpanded = forceExpanded;
        },
    },
    getters: {
        isExpanded() {
            return this.forceExpanded || this.expanded;
        },
        computedWorkspaceHeight() {
            if (this.forceExpanded) {
                return expandedHeight;
            }
            return this.expanded ? expandedHeight : collapsedHeight;
        },
        computedMobileWorkspaceHeight() {
            if (this.forceExpanded) {
                return expandedHeight;
            }
            return this.expanded ? expandedHeightMobile : collapsedHeight;
        },
    },
});